<template>
	<loader v-if="loading || loadingSeriesAndVolumes" height="80vh" />
	<div v-else class="container ar">
		<div class="top">{{ $t('search.result') }}</div>
		<div class="list" v-if="searchResult && searchResult.data.length > 0">
			<router-link
				v-for="item in searchResult.data"
				:key="item.id"
				:to="{
					name: 'article',
					params: {
						id: item.id,
						name: item.name.ar.replaceSpace(),

						volumeId: item.categories[0].id,
						volumeName: item.categories[0].name.ar.replaceSpace(),
						serieId: item.categories[0].set_id,
						serieName: getSerieName(item.categories[0].set_id).replaceSpace(),
					},
				}"
				class="item">
				<div class="title">{{ item.name.ar }}</div>
				<div>
					<div class="name" v-if="item.publishers?.length && false">
						<router-link
							class="name-link"
							v-for="publisher in item.publishers_ids"
							:key="publisher.id"
							:to="{
								name: 'publisher',
								params: {
									id: publisher.publisherName.id,
									name: publisher.publisherName.name.replaceSpace(),
								},
							}">
							{{ publisher.publisherName.name }}
							(
							{{ publisher.statusTitle.name }}
							)
						</router-link>
					</div>
					<div class="date" v-if="item.approved_Date">
						{{ momentRev(item.approved_Date).format('YYYY MMMM DD') }}
					</div>
				</div>
				<div>
					<div class="series">
						<router-link
							:to="{
								name: 'serie',
								params: {
									id: item.categories[0].set_id,
									name: getSerieName(item.categories[0].set_id).replaceSpace(),
								},
							}">
							{{ getSerieName(item.categories[0].set_id) }}
						</router-link>
					</div>
					<div class="issue">
						<router-link
							:to="{
								name: 'all-articles',
								params: {
									id: item.categories[0].id,
									name: item.categories[0].name.ar.replaceSpace(),
									serieId: item.categories[0].set_id,
									serieName: getSerieName(item.categories[0].set_id).replaceSpace(),
								},
							}">
							{{ getVolumeName(item.categories[0].id) }}
						</router-link>
					</div>
				</div>
			</router-link>

			<div class="pagination-container">
				<div class="pagination-items">
					<div
						class="pagination-button"
						:class="{ active: item === searchResult.current_page }"
						@click="moveToPage(item)"
						v-for="item in searchResult.last_page"
						:key="item">
						{{ item }}
					</div>
				</div>
				<div class="pagination-infos">
					{{ searchResult.from }}
					-
					{{ searchResult.to }}
					مقالة
					<!-- {{ searchResult.current_page }}
					\
					{{ searchResult.last_page }}
					صفحة -->
				</div>
			</div>
		</div>
		<div class="empty" v-else>{{ $t('search.no-data') }}...</div>
	</div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import { momentRev } from '@/helpers';
import { mapGetters } from 'vuex';
export default {
	props: [
		'search',
		'issn',
		'startDate',
		'endDate',
		'keyword',
		'article',
		'publisher',
		'serie',
		'volume',
		'loadingSeriesAndVolumes',
	],

	data() {
		return {
			/*
			_searchResult: [],
			get searchResult() {
				return this._searchResult;
			},
			set searchResult(value) {
				this._searchResult=value;
			},
			*/

			loading: true,
			searchResult: [],

			activePage: null,
		};
	},

	components: {
		Loader,
	},

	watch: {
		searchQueryChanged() {
			if (this.search) {
				this.fetchSearch();
			} else {
				this.fetchAdvanceSearch();
			}
		},
	},

	methods: {
		moveToPage(page) {
			this.activePage = page;
			this.$router.push({
				name: 'search-result',
				query: {
					...this.$route.query,
					page: page,
				},
			});
		},
		fetchSearch() {
			this.loading = true;
			this.searchResult = null;
			this.$store
				.dispatch('articles/search', {
					search: this.search,
					page: this.activePage,
				})
				.then((data) => {
					this.searchResult = data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		fetchAdvanceSearch() {
			this.loading = true;
			this.searchResult = null;
			this.$store
				.dispatch('articles/advanceSearch', {
					issn: this.issn,
					startDate: this.startDate ? this.startDate + '-1-1' : null,
					endDate: this.endDate ? this.endDate + '-12-31' : null,
					keyword: this.keyword,
					product: this.article,
					publisher: this.publisher,
					set: this.serie,
					category: this.volume,
					page: this.activePage,
				})
				.then((data) => {
					console.log(data);
					this.searchResult = data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		backward(arr) {
			return arr.map((e) => e).reverse();
		},
		dig(getter, id, ...props) {
			var object = {};
			object = this[getter](id);
			if (props.length > 0 && object) {
				props.forEach((prop) => {
					object = object[prop];
				});
			}
			return object;
		},

		getSerieName(id) {
			return this.dig('getSerieById', id, 'name');
		},

		getVolumeName(id) {
			return this.dig('getVolumeById', id, 'name');
		},

		momentRev,
	},

	computed: {
		searchQueryChanged() {
			return `${this.search} , ${this.issn} , ${this.startDate} , ${this.endDate} , ${this.keyword} , ${this.article} , ${this.publisher} , ${this.serie} , ${this.volume} , ${this.activePage}`;
		},

		...mapGetters({
			getVolumeById: 'volumes/getVolumeById',
			getSerieById: 'series/getSerieById',
		}),
	},

	mounted() {
		this.activePage = this.$route.query.page || 1;
		if (this.search) {
			this.fetchSearch();
		} else {
			this.fetchAdvanceSearch();
		}
	},
};
</script>

<style scoped>
.pagination-container {
	display: flex;
	align-items: center;
	margin-top: 2rem;
}
.pagination-items {
	display: flex;
	margin-left: 1rem;
}
.pagination-button {
	cursor: pointer;
	width: 2rem;
	height: 2rem;
	display: flex;
	justify-content: center;
	border-radius: 5px;
	align-items: center;
	border: 1px solid #34854b;
	margin: 0 3px;
}
.pagination-button:hover {
	background-color: #34854b38;
}
.pagination-button.active {
	background-color: #34854b65;
}

.container {
	margin: 50px 0;
}
.container > * {
	margin: 0 50px;
}
.top {
	padding: 20px 0;
	color: var(--green-color);
	font-family: changeBold;
	font-size: 30px;
}
.list {
	display: flex;
	flex-direction: column;
	border-top: 2px solid var(--borders-color);
	padding: 30px 0;
}
.item {
	padding: 20px 10px;
	border-bottom: 1px solid var(--borders-color);
}
.item > div {
	display: flex;
	justify-content: flex-start;
}
.title {
	display: inline-block;
	width: 100%;
	font-family: changeBold;
	font-size: 20px;
	margin-bottom: 7px;
}
.name,
.date {
	font-size: 16px;
	font-family: changeMedium;
	margin-bottom: 15px;
}
.name,
.series {
	padding-inline-end: 30px;
}
.series,
.issue {
	color: #888;
	font-size: 14px;
	margin-bottom: 10px;
}
.item > *::before {
	font-weight: 700;
	padding: 0 2px;
}
.series::before {
	content: 'اسم السلسلة : ';
}
.issue::before {
	content: 'رقم العدد : ';
}
.name::before {
	content: 'اسم الباحث : ';
}
.date::before {
	content: 'تاريخ قبول النشر : ';
}
.name-link {
	display: inline-block;
	width: max-content;
}
.name-link:not(:last-child):after {
	content: ',\00a0';
}
.empty {
	border-top: 2px solid var(--borders-color);
	padding: 50px 10px;
	font-size: 18px;
	font-family: changebold;
	color: #888;
}
@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
	.top {
		font-size: 28px;
	}
	.title {
		margin-bottom: 14px;
		font-size: 18px;
	}
	.series,
	.issue,
	.name,
	.date {
		width: 100%;
		margin-bottom: 7px;
		font-size: 14px;
	}
	.name {
		margin-bottom: 5px;
	}
}
@media only screen and (max-width: 576px) {
	.item > div {
		display: block;
	}
}
</style>
